module.exports = __webpack_public_path__ + "static/media/logoTicketFooter.9eafbfaa.png";